module.exports = __webpack_public_path__ + "img/right2.a5ff08d0.png";